import { apiProxyRequest } from "Api/apiProxyRequest";
import { fetchAllPages } from "Api/utils";

import type { InvoicesResponse } from "../types";

export const getProfileInvoicesRequest = (billingProfileId: string) => {
  return fetchAllPages(
    apiProxyRequest<InvoicesResponse>(
      `/billing/profiles/${billingProfileId}/invoices`
    )
  );
};
